import React, { Component } from 'react'
import ReactGA from 'react-ga'
import styled from 'styled-components'
import { Card, FlexWrapper, DefaultText, Icon, Arrow } from './'
const IconWrap = styled.div`
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`
class ActionCard extends Component {
  state = {}
  trackButtonClick = () => {
    this.props.onTouch()
    ReactGA.event({
      category: this.props.namespace || 'default',
      action: 'Button Clicked',
      label: 'default',
      nonInteraction: true
    })
  }
  render() {
    const { label, icon, onTouch, iconTwo, iconThree, ...props } = this.props
    return (
      <Card
        borderRadius="5px"
        bgColor={'#fff'}
        padding={'16px'}
        onClick={() => (onTouch ? this.trackButtonClick() : null)}
        {...props}>
        <FlexWrapper direction="row" alignItems="center" justifyContent="space-between">
          <FlexWrapper direction="row" alignItems="center">
            <DefaultText color="#124b5f" padding="0 20px 0 0">
              {label}
            </DefaultText>
            {icon && <Icon icon={icon} color="#124b5f" />}
            {iconTwo && (
              <IconWrap>
                <Icon icon={iconTwo} color="#124b5f" />
              </IconWrap>
            )}
            {iconThree && <Icon icon={iconThree} color="#124b5f" />}
          </FlexWrapper>
          <Arrow color="#124b5f" rotate="-135" />
        </FlexWrapper>
      </Card>
    )
  }
}

export default ActionCard



// WEBPACK FOOTER //
// ./src/components/ActionCard.js